import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

import { RcDropdown, RcDropdownTrigger, RcDropdownItem } from '@components/RcDropdown';
type HiddenAction = {
  action: string;
  enabled: boolean;
  icon: string;
  label: string;
  bulkable: boolean;
  bulkAction: string;
  allEnabled: boolean;
  anyEnabled: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionDropdownShell',
  props: {
    disabled: { type: Boolean },
    hiddenActions: {},
    actionTooltip: {}
  },
  emits: ['click', 'mouseover', 'mouseleave'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const applyTableAction = (act: HiddenAction, args: unknown, event: Event) => {
  emit('click', act, args, event);
};

const setBulkActionOfInterest = (act: HiddenAction | null, event: 'mouseover' | 'mouseleave' = 'mouseover') => {
  emit(event, act);
};

return (_ctx: any,_cache: any) => {
  const _directive_clean_html = _resolveDirective("clean-html")!
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!

  return (_openBlock(), _createBlock(_unref(RcDropdown), {
    distance: 14,
    placement: "bottom"
  }, {
    dropdownCollection: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiddenActions, (act, i) => {
        return _withDirectives((_openBlock(), _createBlock(_unref(RcDropdownItem), {
          key: i,
          disabled: !act.enabled,
          onClick: ($event: any) => (applyTableAction(act, null, $event)),
          onMouseover: ($event: any) => (setBulkActionOfInterest(act)),
          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (setBulkActionOfInterest(null, 'mouseleave')))
        }, {
          before: _withCtx(() => [
            (act.icon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(act.icon)
                }, null, 2))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createTextVNode()),
            _withDirectives(_createElementVNode("span", null, null, 512), [
              [_directive_clean_html, act.label]
            ])
          ]),
          _: 2,
          __: [5]
        }, 1032, ["disabled", "onClick", "onMouseover"])), [
          [_directive_clean_tooltip, {
          content: _ctx.actionTooltip,
          placement: 'right'
        }]
        ])
      }), 128))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(RcDropdownTrigger), {
        class: "bulk-actions-dropdown",
        disabled: _ctx.disabled
      }, {
        before: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "icon icon-gear" }, null, -1)
        ])),
        after: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "ml-10 icon icon-chevron-down" }, null, -1)
        ])),
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("span", null, _toDisplayString(_ctx.t('sortableTable.bulkActions.collapsed.label')), 1),
          _cache[4] || (_cache[4] = _createTextVNode())
        ]),
        _: 1,
        __: [3,4]
      }, 8, ["disabled"]),
      _cache[6] || (_cache[6] = _createTextVNode())
    ]),
    _: 1,
    __: [6]
  }))
}
}

})